import useStateHandler from "@/components/pages/contact/hooks/use-state-handler";
import emailValidator from "email-validator";
import { VoiceModel } from "@/actions/db/get-models";
import { getVoiceModelConvertLink } from "@/utils/link";
import { useGlobalModalContext } from "@/providers/modal-provider/modal-provider";
import { sendVoiceMail } from "@/actions/share-voice/share-voice";
import { editUserModel } from "@/actions/model/edit-user-model";
import { useState } from "react";
import { useLoggingContext } from "@/providers/logging-provider/logging-provider";
import { useProfileContext } from "@/providers/profile-provider/profile-provider";
import { showPublicVoicesNotSupportedError } from "@/utils/notification-helper";

export const useShareVoice = () => {
  const logger = useLoggingContext();

  const {
    value: email,
    isValid: isEmailValid,
    handler: handleEmailChanged,
  } = useStateHandler<string>((value) => emailValidator.validate(value), "");

  const { license } = useProfileContext();

  const [isSending, setIsSending] = useState(false);

  const { hideModal } = useGlobalModalContext();

  const sendEmail = async (voiceModel: VoiceModel) => {
    if (license === "Trial") {
      showPublicVoicesNotSupportedError();
      return;
    }

    setIsSending(true);
    let isVoiceEdited = false;

    try {
      if (!voiceModel.isPublic) {
        await editUserModel(voiceModel.id, { policy: "Public" });
        isVoiceEdited = true;
      }

      const linkToModel = getVoiceModelConvertLink(voiceModel);
      await sendVoiceMail(email, voiceModel.name, linkToModel);
    } catch (err) {
      logger.logError(err as Error);
    } finally {
      setIsSending(true);
      if (isVoiceEdited) {
        window.location.reload();
      } else {
        hideModal();
      }
    }
  };

  return {
    email,
    isEmailValid,
    handleEmailChanged,
    sendEmail,
    isSending,
  };
};
